module.exports = __webpack_public_path__ + "img/icon-binoculars.8876a797.svg";